<template>
  <div :bordered="false">
    <div class="table-page-search-wrapper">
      <div class="table-operator"  style="margin-top: 5px">
        <a-button @click="handleAdd" type="primary" icon="plus">{{ $t('add') }}</a-button>
        <a-button @click="handleFlush" type="primary" icon="reload">{{ $t('flush') }}</a-button>
        <a-popconfirm :title="$t('confirmDelete')" @confirm="() => handleClear()" icon="delete">
          <a-button type="primary" icon="delete">{{ $t(I18N_KEY + 'clear') }}</a-button>
        </a-popconfirm>
      </div>
      <a-table
        ref="table"
        size="middle"
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="false"
        :loading="loading"
        bordered>
        <span slot="action" slot-scope="text, record">
        <a @click="handleEdit(record)" v-if='record.typeStr != "other"'>{{ $t('edit') }}</a>
          <a-divider type="vertical" v-if='record.typeStr != "other"'/>
        <a-dropdown v-if='record.typeStr != "other"'>
          <a class="ant-dropdown-link">
            {{ $t('more') }} <a-icon type="down" />
          </a>
          <a-menu slot="overlay">
            <a-menu-item>
              <a-popconfirm :title="$t('confirmDelete')" @confirm="() => handleDelete(record)">
                <a>{{ $t('delete') }}</a>
              </a-popconfirm>
            </a-menu-item>
          </a-menu>
      </a-dropdown>
      </span>
      </a-table>
      <div style="margin-top: 15px; text-align: right;">
      </div>
      <tele-market-user-group-type-config-edit ref="modalForm" :group-id='groupId' :telemarket-types='types' @ok="modalFormOk"></tele-market-user-group-type-config-edit>
    </div>
  </div>
</template>
<script>
import { userGroupTypeConfigList,userGroupTypeConfigEdit } from '@/webpublicapi/teleMarket'
import TeleMarketUserGroupTypeConfigEdit from './modules/TeleMarketUserGroupTypeConfigEdit'
import moment from "moment";
const I18N_KEY = 'teleMarket.';
export default {
  name: 'TeleMarketUserGroupTypeConfig',
  props: {
    groupId: {
      type: [String, Number],
      default: undefined,
    },
    types:{
      type: Array,
      default: () => [],
    },
    fieldName: {
      type: String,
      default: 'textCn',
    }
  },
  components: {
    TeleMarketUserGroupTypeConfigEdit,
  },
  data () {
    return {
      I18N_KEY,
      loading: false,
      total: 0,
      visible: false,
      dataSource: [],
      id: undefined,
    }
  },
  computed: {
    // Table header
    columns () {
      return [
        {
          title: this.$t(I18N_KEY + 'id'),
          align:"center",
          dataIndex: 'id',
        },
        {
          title: this.$t(I18N_KEY + 'type'),
          align: 'center',
          dataIndex: 'types',
          customRender: (text, record) => {
            var text = text;
            var textStr = record.typeStr
            if(textStr != undefined && textStr != null && textStr != '' && textStr != 'other') {
              var result = '';
              for (const s in text) {
                for(var i in this.types) {
                  if(text[s] === this.types[i].value) {
                    if(result == '') {
                      result = this.types[i][this.fieldName]
                    } else {
                      result = result + ',' + this.types[i][this.fieldName]
                    }
                  }
                }
              }
              return result;
            } else if(textStr == 'other'){
              return this.$t(I18N_KEY + 'other');
            } else {
              return '';
            }
          },
        },
        {
          title: this.$t(I18N_KEY + 'typeConfigNum'),
          align:"center",
          dataIndex: 'num',
        },
        {
          title: this.$t(I18N_KEY + 'operate'),
          dataIndex: 'action',
          align:"center",
          fixed:"right",
          scopedSlots: { customRender: 'action' },
        }]
    },
  },
  created () {
    this.loadData()
  },
  methods: {
    handleClear() {
      this.createSeat(null, "4");
    },
    handleFlush() {
      this.loadData();
    },
    modalFormOk(data) {
      this.createSeat(data);
    },
    handleAdd () {
      this.id = undefined;
      this.$refs.modalForm.add();
      this.$refs.modalForm.title = "1";
      this.$refs.modalForm.disableSubmit = false;
    },
    handleEdit (record) {
      this.id = record.id;
      this.$refs.modalForm.edit(record);
      this.$refs.modalForm.title = "2";
      this.$refs.modalForm.disableSubmit = false;
    },
    handleDelete(record) {
      this.createSeat(record, "3");
    },
    changeModal (visible) {
      this.visible = visible;
    },
    createSeat (data, opt) {
      console.log(data)
      const form = {
        ...data,
        groupId: this.groupId,
        opt: opt?opt:(this.id ? '2' : '1'),
      };
      console.log(form)
      this.loading = true;
      // const requestField = this.versionId ? '2' : '1'
      userGroupTypeConfigEdit(form).then(res => {
        this.$refs.modalForm.closeLoading();
        this.$refs.modalForm.close();

        if (res.code === 1000) {
          this.loading = false;
          this.$message.success(res.msg);
          this.loadData();
        } else {
          this.loading = false;
          this.$message.error(res.msg);
        }
      }).catch(e => {
        this.loading = false;
        this.$refs.modalForm.closeLoading();
        this.$message.error(e.message);
      })
    },
    transformTime(time) {
      return moment(time).format('YYYY-MM-DD')
    },
    searchReset () {
      this.createdTime = [],
        this.queryParam.pageNum=1
      this.queryParam.pageSize=10
      this.queryParam.type=null
      // this.queryParam.startDate=null
      // this.queryParam.endDate=null
    },
    loadData () {
      this.loading = true;
      var param = {groupId: this.groupId}
      userGroupTypeConfigList(param).then(res => {
        this.loading = false;
        this.dataSource = res.data;
      }).catch(e => {
        this.loading = false;
        this.$message.error(e.message);
      });
    }
  },
}
</script>
<style scoped>
@import '~@/assets/less/common.less';
</style>
